import { j as e } from "../../../node_modules/react/jsx-runtime.js";
import { clsx as S } from "../../../node_modules/clsx/dist/clsx.m.js";
import { memo as k, useRef as w, useState as u, useCallback as n } from "react";
import t from "./SegmentedControlItem.module.scss.js";
import { Typography as E } from "../Typography/Typography.js";
import N from "../Icon/Icon.js";
import O from "../Badge/Badge.js";
const R = (p) => {
  const {
    type: a,
    label: g = "option",
    iconName: x,
    selected: s = !1,
    disabled: c,
    compact: i,
    onClick: r,
    testId: y,
    badge: o,
    ...C
  } = p, l = w(null), [m, d] = u(!1), [b, f] = u(!1), h = n(() => {
    d(!0);
  }, []), j = n(() => {
    d(!1), f(!1);
  }, []), v = n(() => {
    f(!0);
  }, []), I = n(
    (M) => {
      r && r(M), l.current && l.current.blur();
    },
    [r]
  );
  return /* @__PURE__ */ e.jsx(
    "button",
    {
      ref: l,
      className: S(t.segmentedControlItem, {
        [t.disabled]: c,
        [t.compact]: i,
        [t.selected]: s,
        [t.iconOnly]: a == "iconOnly"
      }),
      style: t,
      disabled: c,
      role: "segmented-control-item",
      "aria-roledescription": "segmented-control-item",
      "data-testid": y,
      onClick: I,
      onMouseEnter: h,
      onMouseLeave: j,
      onMouseDown: v,
      type: "button",
      ...C,
      children: a == "iconOnly" ? /* @__PURE__ */ e.jsx(
        N,
        {
          style: { flexGrow: 1 },
          name: x || ""
        }
      ) : /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
        /* @__PURE__ */ e.jsx(
          E,
          {
            text: g,
            variant: i ? "interface/medium/s" : "interface/medium/sm",
            textColor: s || m || b ? "color/fg/brand/default" : "color/fg/lighter"
          }
        ),
        o && /* @__PURE__ */ e.jsx(
          O,
          {
            className: "flex items-center justify-center",
            label: o == null ? void 0 : o.toString(),
            variant: "tinted",
            color: s || m ? "primary" : "gray"
          }
        )
      ] })
    }
  );
}, T = k(R);
export {
  T as default
};
//# sourceMappingURL=SegmentedControlItem.js.map
